import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { dataFetched, makesMutations } from 'data/graphql'
import { paymentInfosFragment } from './fragments'

const SubscribeToPlanQuery = gql`
  mutation SubscribeToPlan($input: PlanSubscriptionInput!) {
    subscribeToPlan(input: $input) {
      ...paymentInfosAttrs
    }
  }
  ${paymentInfosFragment}
`

const providesSubscribeToPlan = compose(
  connect(
    null,
    { dataFetched }
  ),
  makesMutations({
    query: SubscribeToPlanQuery,
    mutationPropName: 'subscribeToPlan',
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      dataFetched(result.data.subscribeToPlan)
      return result
    },
  })
)

export default providesSubscribeToPlan
